module.exports = __webpack_public_path__ + "img/9788960179677.878b6ad6.jpg";